module.exports = require("./../../_gen/starling/textures/TextureSmoothing");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/textures/TextureSmoothing.js
// module id = 240
// module chunks = 0